import {axiosInstanceToken} from "../../../../app/api";
import {ICareerResponse, ISaveCareerRequest} from "../../../../interface/Passport/Career/backend";
import {IOptionsResponse} from "../../../../interface/Passport/Education/backend";

export async function getPlacesOfWork(): Promise<IOptionsResponse> {
    return axiosInstanceToken.get<IOptionsResponse>('/place-of-work').then(result => result.data)
}

export async function getPosts(): Promise<IOptionsResponse> {
    return axiosInstanceToken.get<IOptionsResponse>('/post').then(result => result.data)
}

export async function getCareers(): Promise<ICareerResponse> {
    return axiosInstanceToken.get<ICareerResponse>('/career').then(result => result.data)
}

export async function saveCareer(data: ISaveCareerRequest): Promise<undefined> {
    return axiosInstanceToken.put('/career', data).then(result => result.data)
}

export async function deleteCareer(id: number) {
    return axiosInstanceToken.delete('/career', {data: {id}}).then(result => result.data)
}

